import React, { Component } from 'react';
import withRouter from "./components/withRouter"
import requester from '../library/Requester';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Image, Card, Table , Badge } from 'react-bootstrap';
import * as fn from '../library/function';
import * as util from '../library/utilitys';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import SearchView from './components/ui/SearchView';
import Dropdown from './components/ui/Dropdown';
import styles from '../styles/frontend/SummaryData.module.css';
import * as Actions from './actions/ActionCenter';
import { calendarDays, weekDays } from './FrontendHomepage';

const ATTACH_FILE_CONTENT_URL = `public/view/attach_files/files`;

const URL = `public/view/frontent/tops-info`;

const typeAPoster = '/images/poster_type_a.png';
const typeBPoster = '/images/poster_type_b.png';
const typeCPoster = '/images/poster_type_c.png';

  const typeAColumns = [
    { key: 'institution', title: 'สถาบันการศึกษา', style: { backgroundColor: '#173A74', color: '#fff' } },
    { key: 'dual6164', title: 'Type A ทวิภาคี ปี 61-64', align: 'center', style: { backgroundColor: '#4A79C9', color: '#fff' } },
    { key: 'dual6567', title: 'Type A ทวิภาคี ปี 65-67', align: 'center', style: { backgroundColor: '#114FA3', color: '#fff' } },
    { key: 'full6567', title: 'Type A 100% ปี 65-67', align: 'center', style: { backgroundColor: '#173A74', color: '#fff' } },
    { key: 'total', title: 'รวม', align: 'center', style: { backgroundColor: '#F59E0B', color: '#fff' } }
  ];

  const typeAData = [
    { institution: 'วิทยาลัยการอาชีพบางปะกง', dual6164: '492', dual6567: '0', full6567: '492', total: '492' },
    { institution: 'วิทยาลัยเทคนิคจุฬาภรณ์ (ลาดขวาง)', dual6164: '278', dual6567: '0', full6567: '278', total: '278' },
    { institution: 'วิทยาลัยเทคนิคฉะเชิงเทรา', dual6164: '882', dual6567: '0', full6567: '882', total: '882' },
    { institution: 'วิทยาลัยเทคนิคพนมสารคาม', dual6164: '965', dual6567: '0', full6567: '965', total: '965' },
    { institution: 'วิทยาลัยเทคโนโลยีการจัดการนวัตกรรม', dual6164: '501', dual6567: '0', full6567: '501', total: '501' },
    { institution: 'วิทยาลัยเทคโนโลยีบางปะกงบริหารธุรกิจ', dual6164: '953', dual6567: '0', full6567: '953', total: '953' },
    { institution: 'วิทยาลัยเทคโนโลยียานยนต์โตโยต้า', dual6164: '231', dual6567: '0', full6567: '231', total: '231' },
    { institution: 'วิทยาลัยเทคโนโลยีศรีวรการ', dual6164: '405', dual6567: '0', full6567: '405', total: '405' },
    { institution: 'วิทยาลัยอาชีวศึกษาฉะเชิงเทรา', dual6164: '430', dual6567: '0', full6567: '430', total: '430' },
    { institution: 'วิทยาลัยเทคโนโลยีฉะเชิงเทรา', dual6164: '403', dual6567: '0', full6567: '403', total: '403' },
    { institution: 'วิทยาลัยเทคโนโลยีอาเซียนไทยบ้านโพธิ์', dual6164: '471', dual6567: '0', full6567: '471', total: '471' },
    { institution: 'วิทยาลัยเกษตรและเทคโนโลยีฉะเชิงเทรา', dual6164: '2', dual6567: '0', full6567: '2', total: '2' },
    { institution: 'มหาวิทยาลัยเกษตรศาสตร์ ศรีราชา', dual6164: '0', dual6567: '2', full6567: '2', total: '2' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลตะวันออก', dual6164: '0', dual6567: '111', full6567: '111', total: '111' },
    { institution: 'มหาวิทยาลัยธรรมศาสตร์ วิทยาเขตพัทยา', dual6164: '0', dual6567: '3', full6567: '3', total: '3' },
    { institution: 'มหาวิทยาลัยบูรพา', dual6164: '0', dual6567: '2', full6567: '2', total: '2' },
    { institution: 'ผลผลิตรวม EEC', dual6164: '2,204', dual6567: '62,567', full6567: '1,833', total: '64,400', isTotal: true }
  ];

    // EEC Model Type B Table Data
const typeBColumns = [
  { key: 'institution', title: 'สถาบันการศึกษา/หน่วยงาน', width: 'w-109' ,style: { backgroundColor: '#173A74', color: '#fff' } },
  { key: 'year2563', title: '2563', width: 'w-25', align: 'center', style: { backgroundColor: '#4A79C9', color: '#fff' } },
  { key: 'year2564', title: '2564', width: 'w-25', align: 'center', style: { backgroundColor: '#114FA3', color: '#fff' } },
  { key: 'year2565', title: '2565', width: 'w-25', align: 'center', style: { backgroundColor: '#173A74', color: '#fff' } },
  { key: 'year2566', title: '2566', width: 'w-25', align: 'center', style: { backgroundColor: '#4A79C9', color: '#fff' } },
  { key: 'year2567', title: '2567', width: 'w-25', align: 'center', style: { backgroundColor: '#114FA3', color: '#fff' } },
  { key: 'year2568', title: '2568', width: 'w-25', align: 'center', style: { backgroundColor: '#173A74', color: '#fff' } },
  { key: 'total', title: 'รวมทั้งสิ้น', width: 'w-25', align: 'center', style: { backgroundColor: '#F59E0B', color: '#fff' } }
];
const typeBHeader = [
  { key: 'course', title: 'รหัสหลักสูตร', width: '12%' , align: 'center', style: { backgroundColor: '#173A74', color: '#fff' } },
  { key: 'coursename', title: 'ชื่อหลักสูตร', width: '35%', align: 'center', style: { backgroundColor: '#4A79C9', color: '#fff' } },
  { key: 'academy', title: 'ชื่อสถานศึกษา', width: '20%', align: 'center', style: { backgroundColor: '#114FA3', color: '#fff' } },
  { key: 'target_industrie', title: 'ประเภทอุตสาหกรรมเป้าหมาย', width: '15%', align: 'center', style: { backgroundColor: '#F59E0B', color: '#fff' } },
];

  const typeBData = [
    { institution: 'มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี', year2563: '0', year2564: '0', year2565: '88', year2566: '224', year2567: '229', year2568: '0', total: '541' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ', year2563: '0', year2564: '30', year2565: '293', year2566: '549', year2567: '627', year2568: '0', total: '1,591' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลตะวันออก', year2563: '0', year2564: '0', year2565: '56', year2566: '265', year2567: '561', year2568: '92', total: '882' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลธัญบุรี', year2563: '0', year2564: '10', year2565: '0', year2566: '20', year2567: '49', year2568: '0', total: '79' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลรัตนโกสินทร์', year2563: '0', year2564: '0', year2565: '0', year2566: '178', year2567: '65', year2568: '0', total: '243' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา', year2563: '0', year2564: '0', year2565: '0', year2566: '0', year2567: '2', year2568: '0', total: '2' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลสุวรรณภูมิ', year2563: '0', year2564: '0', year2565: '0', year2566: '1,433', year2567: '895', year2568: '0', total: '2,328' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีสุรนารี', year2563: '0', year2564: '0', year2565: '0', year2566: '54', year2567: '6', year2568: '0', total: '60' },
    { institution: 'มหาวิทยาลัยบูรพา', year2563: '3,732', year2564: '77', year2565: '195', year2566: '146', year2567: '1,117', year2568: '332', total: '5,599' },
    { institution: 'มหาวิทยาลัยศิลปากร', year2563: '0', year2564: '0', year2565: '0', year2566: '0', year2567: '179', year2568: '0', total: '179' },
    { institution: 'มหาวิทยาลัยมหิดล', year2563: '0', year2564: '0', year2565: '0', year2566: '0', year2567: '0', year2568: '679', total: '679' },
    { institution: 'วิทยาลัยเทคโนโลยีทางทะเลแห่งเอเชีย', year2563: '0', year2564: '0', year2565: '0', year2566: '27', year2567: '1,407', year2568: '0', total: '1,434' },
    { institution: 'วิทยาลัยเทคโนโลยีปัญญาภิวัฒน์', year2563: '0', year2564: '25', year2565: '0', year2566: '0', year2567: '0', year2568: '0', total: '25' },
    { institution: 'วิทยาลัยเทคโนโลยีวิศวกรรมแหลมฉบัง', year2563: '0', year2564: '0', year2565: '67', year2566: '0', year2567: '0', year2568: '0', total: '67' },
    { institution: 'ศูนย์เทคโนโลยีอิเล็กทรอนิกส์และคอมพิวเตอร์แห่งชาติ สวทช.', year2563: '0', year2564: '0', year2565: '0', year2566: '117', year2567: '19', year2568: '0', total: '136' },
    { institution: 'สถาบันเทคโนโลยีการผลิตสุมิพล', year2563: '0', year2564: '0', year2565: '96', year2566: '0', year2567: '126', year2568: '0', total: '222' },
    { institution: 'สถาบันไทย-ญี่ปุ่น', year2563: '0', year2564: '30', year2565: '0', year2566: '30', year2567: '30', year2568: '0', total: '90' },
    { institution: 'สถาบันไทย-เยอรมัน', year2563: '0', year2564: '49', year2565: '1,207', year2566: '2,037', year2567: '2,794', year2568: '204', total: '6,291' },
    { institution: 'รวมทั้งสิ้น', year2563: '3,732', year2564: '221', year2565: '2,002', year2566: '5,080', year2567: '8,106', year2568: '1,307', total: '20,448', isTotal: true }
  ];

  const institutions = [
    "จุฬาลงกรณ์มหาวิทยาลัย",
    "มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตศรีราชา",
    "มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี",
    "มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ",
    "มหาวิทยาลัยเทคโนโลยีราชมงคลตะวันออก",
    "มหาวิทยาลัยเทคโนโลยีราชมงคลธัญบุรี",
    "มหาวิทยาลัยเทคโนโลยีราชมงคลรัตนโกสินทร์",
    "มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา",
    "มหาวิทยาลัยเทคโนโลยีราชมงคลสุวรรณภูมิ",
    "มหาวิทยาลัยเทคโนโลยีสุรนารี",
    "มหาวิทยาลัยบูรพา",
    "มหาวิทยาลัยมหิดล",
    "มหาวิทยาลัยศิลปากร",
    "มหาวิทยาลัยราชภัฏราชนครินทร์",
    "วิทยาลัยเทคโนโลยีทางทะเลแห่งเอเชีย",
    "วิทยาลัยเทคโนโลยีปัญญาภิวัฒน์",
    "วิทยาลัยเทคโนโลยีวิศวกรรมแหลมฉบัง",
    "สถาบันพัฒนาบุคลากรสาขาเทคโนโลยีการผลิตอัตโนมัติและหุ่นยนต์",
    "สถาบันเทคโนโลยีการผลิตสุมิพล",
    "สถาบันไทย-ญี่ปุ่น",
    "สถาบันไทย-เยอรมัน",
    "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.)"
  ];

  const courseCountColumns = [
    { key: 'institution', title: 'สถาบันการศึกษา', width: 'w-234',style: { backgroundColor: '#173A74', color: '#fff' } },
    { key: 'count', title: 'จำนวนหลักสูตร', width: 'w-50', align: 'center',style: { backgroundColor: '#173A74', color: '#fff' }}
  ];

  const courseCountData = [
    { institution: 'มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี', count: '11' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ', count: '13' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลตะวันออก', count: '71' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลธัญบุรี', count: '12' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลรัตนโกสินทร์', count: '6' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา', count: '3' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีราชมงคลสุวรรณภูมิ', count: '12' },
    { institution: 'มหาวิทยาลัยเทคโนโลยีสุรนารี', count: '2' },
    { institution: 'มหาวิทยาลัยบูรพา', count: '18' },
    { institution: 'มหาวิทยาลัยศิลปากร', count: '10' },
    { institution: 'มหาวิทยาลัยมหิดล', count: '4' },
    { institution: 'วิทยาลัยเทคโนโลยีทางทะเลแห่งเอเชีย', count: '4' },
    { institution: 'วิทยาลัยเทคโนโลยีปัญญาภิวัฒน์', count: '27' }
  ];

  const demandColumns = [
    { key: 'model', title: 'EEC Model', width: 'w-30' },
    { key: 'typeA', title: 'Type A', width: 'w-33', align: 'center' },
    { key: 'typeB', title: 'Type B', width: 'w-33', align: 'center' },
    { key: 'typeBMara', title: 'Type B MARA', width: 'w-33', align: 'center' },
    { key: 'automotive', title: 'โครงการชะลอการว่างงานในอุตสาหกรรมยานยนต์', width: 'w-50', align: 'center' },
    { key: 'total', title: 'รวม', width: 'w-30', align: 'center' }
  ];

  const demandData = [
    { model: '2563', typeA: '665', typeB: '3,732', typeBMara: 'n.a.', automotive: 'n.a.', total: '4,397' },
    { model: '2564', typeA: '1,539', typeB: '221', typeBMara: '132', automotive: '4,986', total: '5,878' },
    { model: '2565', typeA: '48,372', typeB: '2,002', typeBMara: '421', automotive: '0', total: '50,795' },
    { model: '2566', typeA: '6,603', typeB: '5,080', typeBMara: '2,890', automotive: '0', total: '14,573' },
    { model: '2567', typeA: '7,592', typeB: '8,106', typeBMara: '2,973', automotive: '0', total: '18,671' },
    { model: '2568', typeA: '-', typeB: '1,307', typeBMara: '381', automotive: '0', total: '1,688' },
    { model: 'total 63-68', typeA: '64,771', typeB: '20,448', typeBMara: '6,797', automotive: '4,986', total: '96,002', isTotal: true },
    { model: '2569', typeA: '4,400', typeB: '3,000', typeBMara: '1,000', automotive: '254', total: '8,400' }
  ];

  const additionalDemandColumns = [
    { key: 'cwie', title: 'CWIE', width: 'w-32', align: 'center' },
    { key: 'education', title: 'พัฒนาการศึกษาระดับพื้นฐาน (AI&IOT) โดย สวทช', width: 'w-32', align: 'center' }
  ];

  const additionalDemandData = [
    { cwie: '0', education: '0' },
    { cwie: '0', education: '4,893' },
    { cwie: '43', education: '5,288' },
    { cwie: '155', education: '1,141' },
    { cwie: '151', education: '1,981' },
    { cwie: '-', education: '-' },
    { cwie: '349', education: '13,303', isTotal: true }
  ];

  const institutionRows = [];
  for (let i = 0; i < institutions.length; i += 3) {
    institutionRows.push(institutions.slice(i, i + 3));
  }

class SummaryData extends Component {
    constructor(props) {
    super(props);
    this.state = {
        DataTable3: [],
        selectedMonth: this.getMonthName(new Date()),
        items: [],
        items5: [],
        images: {},
        page: 1,
        pageSize: 10000,
        totalPages: 1,
        courses: {
            rows: [],
            pagination: [],
        },
        coursePage: 1,
    };
  }

  
  componentDidMount() {
    this.loadTrainingCourseData();
  }

    loadTrainingCourseData = async () => {
    const { coursePage, pageSize } = this.state;
    try {
      const response = await requester.post(`public/view/frontent/tops-info/frontend_all_course`, {
        page: coursePage,
        pageSize
      });
      const rows = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};

      this.setState({ courses: {rows,pagination} });

      await this.putDataToState("DataTable3", "frontend_training_course", false, "", { pageSize: 10 });
    } catch (error) {
      console.error('Error fetching training course data:', error);
    }
  };
  
    getMonthName(date) {
        return date.toLocaleString('th-TH', { month: 'long', year: 'numeric' });
    }

    putDataToState = async (stateKey, path, loadImage = false, imageStateKey = "", body = {}, onAfterSetState = null) => {
    try {
      const response = await requester.post(`${URL}/${path}`, body);
      const data = response.data?.data?.data || response.data?.data || [];
  
      this.setState({ [stateKey]: data }, async () => {
        if (onAfterSetState) {
          onAfterSetState(data);
        }
        if (loadImage) {
          await this.loadImages(stateKey, imageStateKey);
        }
      });
    } catch (error) {
      console.error(`Error loading data for ${stateKey} from ${path}`, error);
    }
  };

    loadImages = async (sourceStateKey, targetImageStateKey = "") => {
      const rows = this.state[sourceStateKey] || [];    
  
      const getImage = await Actions.loadImageBlobUrls({
        rows,
        fileField: "photo",
        idField: "id",
        baseUrl: ATTACH_FILE_CONTENT_URL
      });
  
      this.setState({ [targetImageStateKey]: getImage });
      
    };
    

  render() {
    let { courses, DataTable3, selectedMonth } = this.state;  

    // let titleColor = 'text-dark'
    let titleColor = 'text-white'

    const UpArrowIcon = () => null
    //     (<img
    //         // src="/images/img_arrowup_gray_800.svg"
    //         src="/images/img_arrowup_white.svg"
    //         alt="Expand"
    //         width={24}
    //         height={24}
    //     />
    // )

    const TypeAPoster = () => (
        <Row className='my-5'>
            <img
              src={typeAPoster}
              alt=""
              className="rounded shadow-sm mb-5"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
            <p className={`${titleColor} fs-5`}>
                หลักสูตรระดับปริญญา (Degree) หรือประกาศนียบัตรวิชาชีพ (ปวช./ปวส.) ที่สถาบันการศึกษาร่วมมือกับผู้ประกอบการในการพัฒนาหลักสูตรและทักษะบุคลากร เรียนฟรี มีงานทำ รายได้สูงเอกชนจ่ายร้อยละ 100 <br/><span style={{ color: '#f59e0b' }}>เป้าหมาย</span> คือ ตอบโจทย์ภาคธุรกิจและอุตลาหกรรมสร้างบุคลากร ที่มีทักษะศักยภาพพร้อมทำงานทันที และสามารถต่อยอดสำหรับการพัฒนาในระยะยาว
            </p>
        </Row>
    )

    const TypeBPoster = () => (
        <Row className='my-5'>
            <img
              src={typeBPoster}
              alt=""
              className="rounded shadow-sm mb-5"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
            <p className={`${titleColor} fs-5`}>
                Short Course Training หลักสูตรระยะสั้น Re-skill Up-skill ให้คนทำงานก้าวทันการเปลี่ยนแปลงเทคโนโลยีใหม่ รัฐและเอกชนจ่าย (50:50) <br/><span style={{ color: '#f59e0b' }}>เป้าหมาย</span> คือ พัฒนาบุคลากรในภาคอุตลาหกรรมเพื่อรองรับเทคโนโลยีใหม่สร้างทักษะให้คนทำงาน ระยะเร่งด่วนด้วยหลักสูตรระยะสั้น ไม่มีปริญญา(Non-Degree) ทั้งนี้ หลักสูตรจะต้องผ่านการรับรองจากคณะทำงานพิจารณารับรองหลักลูกสูตรฝึกอบรมเพื่อพัฒนาทักษะบุคลากรด้านวิทยาศาศาสตร์ เทคโนโลยีและวิศวกรรม
            </p>
        </Row>
    )

    const TypeCPoster = () => (
        <Row className='my-5'>
            <img
              src={typeCPoster}
              alt=""
              className="rounded shadow-sm mb-5"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
            <p className={`${titleColor} fs-5`}>
                หลักสูตรฝึกอบรมระยะสั้น เพื่อพัฒนากำลังคนรองรับนักลงทุนที่จะเข้ามาลงทุนในพื้นที่ หรือนักลงทุนในพื้นที่ที่มีความต้องการขยายธุรกิจ <br/><span style={{ color: '#f59e0b' }}>เป้าหมาย</span> คือ การฝึกอบรมให้ความรู้ ทักษะในสาขาวิชาที่นักลงทุนต้องการ สกพอ. สนับสนุนค่าใช้จ่ายฝึกอบรม 100% และจัดเก็บค่าใช้จ่ายการฝึกอบรมจากนักลงทุน กรณีมีการจ้างงาน สกพอ. จะดำเนินการผ่านความร่วมมือของ 13 ศูนย์เครื่อข่าย สนับสนุน 5 cluster อุตสาหกรรมเป้าหมายพิเศษ
            </p>
        </Row>
    )

    return (
        <div
        className={styles.pageContainer}
        style={{
            // backgroundImage: "url('/images/img__3.png')",
            backgroundColor: '#002A66',
            backgroundAttachment: 'fixed',
            backgroundSize: 'cover'
        }}
        >
        <Header />

        <Container className="py-10">
            {/* Page Title */}
            <div className="text-center mt-4 mb-4">
            <h1 className={`display-4 fw-bold ${titleColor} mb-3`}>
                {/* ศูนย์ข้อมูล EEC เขตพัฒนาพิเศษภาคตะวันออก */}
                การพัฒนาบุคลากร ตามรูปแบบ EEC Model
            </h1>
            <p className="lead text-secondary">
                "แหล่งรวบรวมข้อมูลผลการพัฒนาบุคลากร EEC Model ทั้งในด้านจำนวนหลักสูตร สถาบันที่เข้าร่วม และสถิติต่าง ๆ"
            </p>
            </div>

            {/* EEC Model Type A Section */}
            <section className=" mt-10 mb-5">
            <Row className="align-items-center mb-4">
                <Col xs="auto">
                <h1 className={`${titleColor} display-5 fw-bold mb-0`} style={{ fontSize: 36 }}>
                    <strong style={{ color: '#f99e39' }}>EEC</strong> Model <span className='fw-normal fst-italic'>type</span> <span>A</span>
                </h1>
                </Col>
                <Col xs="auto">
                <UpArrowIcon/>
                </Col>
            </Row>

            <TypeAPoster/>

            <Row className=" mb-4">
                <Col md={4} className='my-1'>

                    <StatCard title={'66,604'} text={'ผลผลิตรวมปี 2561 - 2567 (คน)'} icon={"/images/img_frame_1686553853.svg"} iconColor={'dark'}/>

                </Col>

                <Col md={4} className='my-1'>

                    <StatCard title={'1,833'} text={'Type A (คน)'} icon={"/images/img_frame_1686553853_white_a700.svg"} iconColor={'warning'}/>

                </Col>

                <Col md={4} className='my-1'>

                    <StatCard title={'64,771'} text={'Type A ทวิภาคี (คน)'} icon={"/images/img_frame_1686553853_white_a700.svg"} iconColor={'success'}/>

                </Col>
            </Row>

            <Table bordered hover responsive className="align-middle mt-5">
                <thead>
                <tr>
                    {typeAColumns.map((col, index) => (
                    <th
                        key={index}
                        className={col.align === 'center' ? 'text-center' : 'text-start'}
                        style={col.style}
                    >
                        {col.title}
                    </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {typeAData.map((row, rowIndex) => (
                    <tr key={rowIndex} className={row.isTotal ? 'fw-bold bg-light' : ''}>
                    {typeAColumns.map((col, colIndex) => (
                        <td
                        key={colIndex}
                        className={col.align === 'center' ? 'text-center' : ''}
                        >
                        {row[col.key]}
                        </td>
                    ))}
                    </tr>
                ))}
                </tbody>
            </Table>

            </section>

            <section className=" mt-10 mb-5">
            <Row className="align-items-center mb-4">
                <Col xs="auto">
                <h1 className={`${titleColor} display-5 fw-bold mb-0`} style={{ fontSize: 36 }}>
                    <strong style={{ color: '#f99e39' }}>EEC</strong> Model <span className='fw-normal fst-italic'>type</span> <span>B</span>
                </h1>
                </Col>
                <Col xs="auto">
                <UpArrowIcon/>
                </Col>
            </Row>

            <TypeBPoster/>

            <Row className=" mb-4">
                <Col md={6} className='my-1'>
                
                    <StatCard title={'20,448'} text={'ปี 2563 – ปัจจุบัน รวมทั้งสิ้น (คน)'} icon={"/images/img_frame_1686553853.svg"} iconColor={'dark'}/>

                </Col>

                <Col md={6}className='my-1'>

                    <StatCard title={'22'} text={'จำนวนสถาบันการศึกษาที่ร่วมผลิตและพัฒนาบุคลากร'} icon={"/images/img_building3.svg"} iconColor={'warning'}/>

                </Col>
            </Row>

            <Table bordered hover responsive className="align-middle mt-5">
                <thead>
                <tr>
                    {typeBColumns.map((col, index) => (
                    <th
                        key={index}
                        className={col.align === 'center' ? 'text-center' : 'text-start'}
                        style={col.style}
                    >
                        {col.title}
                    </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {typeBData.map((row, rowIndex) => (
                    <tr key={rowIndex} className={row.isTotal ? 'fw-bold bg-light' : ''}>
                    {typeBColumns.map((col, colIndex) => (
                        <td
                        key={colIndex}
                        className={col.align === 'center' ? 'text-center' : ''}
                        >
                        {row[col.key]}
                        </td>
                    ))}
                    </tr>
                ))}
                </tbody>
            </Table>
            </section>

            <section className=" mt-8 mb-5">
            <Row className=" mb-1">
                <h3 className={`fs-2 font-prompt font-medium leading-9 text-global-2 mb-6 ${titleColor}`}>
                สถาบันการศึกษาที่ร่วมผลิตและพัฒนาบุคลากรและฝึกอบรม <span style={{ color: '#f99e39' }}>EEC</span> Model Type B
                </h3>
            </Row>

            {institutionRows.map((row, rowIndex) => (
                <Row key={rowIndex} className="mb-2">
                {row.map((name, colIndex) => (
                    <Col key={colIndex}>
                    <p className={`text-base font-prompt font-normal leading-6 text-global-2 mb-2 ${titleColor} fs-5`}>
                        {rowIndex * 3 + colIndex + 1}. {name}
                    </p>
                    </Col>
                ))}
                </Row>
            ))}
            </section>

            <section className=" mt-8 mb-5">
            <Row className=" mb-4">
                <Col md={6} className='my-1'>

                    <StatCard title={'349'} text={'ที่รับรองแล้ว (หลักสูตร)'} icon={"/images/img_frame_1686553853.svg"} iconColor={'dark'}/>

                </Col>
            </Row>

            <div style={{ maxHeight: 800, overflowY: 'auto' }}>
                <Table bordered hover className="align-middle">
                    <thead>
                        <tr>
                            {typeBHeader.map((col, index) => (
                            <th
                                key={index}
                                className={col.align === 'center' ? 'text-center' : 'text-start'}
                                style={{
                                width: col.width,
                                ...col.style,        // ใช้สี/สไตล์เดิมทั้งหมด
                                position: 'sticky',
                                top: 0,
                                zIndex: 2,            // กัน body ทับ
                                }}
                            >
                                {col.title}
                            </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {courses.rows.map((row, index) => {

                            Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                            
                            let del = true;
                            if (['0', '1'].includes(row.status)) { del = false; }

                            return (
                                    <React.Fragment key={`${row.id}`}>
                                        <tr>
                                            <td className="text-truncate td-font-sm" title={row.official_course_code}>{row.official_course_code}</td>
                                            <td className="text-truncate td-font-sm" title={row.th_name}>{row.th_name}</td>
                                            <td className="text-truncate td-font-sm" title={row.academy_name}>{row.academy_name}</td>
                                            <td className="text-truncate td-font-sm" title={row.target_industries_name}>{row.target_industries_name}</td>
                                        </tr>
                                    </React.Fragment>       
                                )
                        })}
                    </tbody>
                </Table>
            </div>

            <Table bordered hover responsive className="align-middle mt-5">
                <thead>
                    <tr>
                        {courseCountColumns.map((col, index) => (
                            <th
                                key={index}
                                className={col.align === 'center' ? 'text-center' : 'text-start'}
                                style={col.style}
                            >
                                {col.title}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {courseCountData.map((row, rowIndex) => (
                        <tr key={rowIndex} className={row.isTotal ? 'fw-bold bg-light' : ''}>
                            {courseCountColumns.map((col, colIndex) => (
                                <td
                                    key={colIndex}
                                    className={col.align === 'center' ? 'text-center' : ''}
                                >
                                    {col.key === 'institution' && !row.isTotal ? (
                                        <>
                                            <Badge bg="primary" className="me-2">
                                                {rowIndex + 1}
                                            </Badge>
                                            {row[col.key]}
                                        </>
                                    ) : (
                                        row[col.key]
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
            </section>

        <section className=" mt-10 mb-5">
            <Row className="align-items-center mb-4">
                    <h1 className={`${titleColor} display-5 fw-bold mb-0`} style={{ fontSize: 36 }}>
                        <strong style={{ color: '#f99e39' }}>EEC</strong> Model <span className='fw-normal fst-italic'>type</span> <span>C</span>
                    </h1>
                <Col xs="auto">
                </Col>
                <Col xs="auto">
                <UpArrowIcon/>
                </Col>
            </Row>

            <TypeCPoster/>

            <Row className=" mb-4">
                <Col md={6} className='my-1'>

                    <StatCard title={'109,654'} text={'ปี 2563-2568 (คน)'} icon={"/images/img_frame_1686553853_white_a700_40x40.svg"} iconColor={'dark'}/>

                </Col>
            </Row>

            {/* <Row className="mt-4">
                <Col md={12}>
                <div className="d-flex flex-row flex-wrap gap-3">
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <Table bordered hover responsive className="align-middle mt-5">
                        <thead>
                        <tr>
                            {demandColumns.map((col, index) => (
                            <th
                                key={index}
                                className={col.align === 'center' ? 'text-center' : 'text-start'}
                                style={col.style}
                            >
                                {col.title}
                            </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {demandData.map((row, rowIndex) => (
                            <tr key={rowIndex} className={row.isTotal ? 'fw-bold bg-light' : ''}>
                            {demandColumns.map((col, colIndex) => (
                                <td
                                key={colIndex}
                                className={col.align === 'center' ? 'text-center' : ''}
                                >
                                {row[col.key]}
                                </td>
                            ))}
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    </div>

                    <div style={{ width: 330 }}>
                    <Table bordered hover responsive className="align-middle mt-5">
                        <thead>
                        <tr>
                            {additionalDemandColumns.map((col, index) => (
                            <th
                                key={index}
                                className={col.align === 'center' ? 'text-center' : 'text-start'}
                                style={col.style}
                            >
                                {col.title}
                            </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {additionalDemandData.map((row, rowIndex) => (
                            <tr key={rowIndex} className={row.isTotal ? 'fw-bold bg-light' : ''}>
                            {additionalDemandColumns.map((col, colIndex) => (
                                <td
                                key={colIndex}
                                className={col.align === 'center' ? 'text-center' : ''}
                                >
                                {row[col.key]}
                                </td>
                            ))}
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    </div>
                </div>

                </Col>
            </Row> */}
            </section>

            
        </Container>

        <Footer />
        </div>
    );
    }
}

export default withRouter(SummaryData);

class StatCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayScore: 0
        };
        this.animationFrame = null;
    }

    componentDidMount() {
        this.startAnimation();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.title !== this.props.title) {
            this.startAnimation();
        }
    }

    componentWillUnmount() {
        if (this.animationFrame) {
            cancelAnimationFrame(this.animationFrame);
        }
    }

    startAnimation = () => {
        const { title } = this.props;

        const end = Number(title.toString().replace(/,/g, ''));
        const duration = 1500;
        const startTime = performance.now();

        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = 1 - Math.pow(1 - Math.min(elapsed / duration, 1), 3);
            const value = Math.floor(progress * end);

            this.setState({
                displayScore: value.toLocaleString()
            });

            if (progress < 1) {
                this.animationFrame = requestAnimationFrame(animate);
            }
        };

        this.setState({ displayScore: 0 });
        this.animationFrame = requestAnimationFrame(animate);
    };

    render() {
        const { text, icon, iconColor } = this.props;
        const { displayScore } = this.state;

        return (
            <Card className='h-100 shadow-sm'>
                <Card.Body className='text-center'>
                    <Row>
                        <Card.Title className='text-uppercase fw-bold text-dark fs-3'>
                            <div
                                className={`bg-${iconColor} text-white rounded d-inline-flex align-items-center justify-content-center m-3`}
                                style={{ width: 40, height: 40 }}
                            >
                                <img src={icon} alt='Icon' width={24} height={24} />
                            </div>

                            {displayScore}
                        </Card.Title>
                    </Row>

                    <Card.Text className='text-muted'>
                        {text}
                    </Card.Text>
                </Card.Body>
            </Card>
        );
    }
}
